var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconTwitter = function SvgIconTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    fillRule: "evenodd",
    d: "M9.25 12.629 1.037 2.178h6.506l5.072 6.46 5.417-6.431h3.584l-7.269 8.637 8.619 10.978h-6.488l-5.49-6.985-5.863 6.966H1.521zm8.173 7.257L5.025 4.114h1.571l12.382 15.772z",
    clipRule: "evenodd"
  })));
};
export default SvgIconTwitter;